import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Chip, CircularProgress } from '@mui/material';
import { useIntl } from 'react-intl';

export interface ListViewLoadMoreProps {
  onLoadMore: () => void;
  isLoadingMore: boolean;
}

/**
 * Chip button that loads the next page of an infinite list.
 * Shows a spinner as label when loading, otherwise "Load more" with chevron icon.
 */
export function ListViewLoadMore({ onLoadMore, isLoadingMore }: ListViewLoadMoreProps) {
  const { $t } = useIntl();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <Chip
        label={
          isLoadingMore ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            $t({
              id: 'common.loadMore',
              defaultMessage: 'Cargar más',
            })
          )
        }
        onClick={onLoadMore}
        disabled={isLoadingMore}
        icon={isLoadingMore ? undefined : <ExpandMoreIcon />}
        sx={{ minWidth: 140 }}
      />
    </Box>
  );
}
